import React, { useState } from 'react';

import PhotoModal from '../modals/PhotoModal'

import '../CommonHomeRouteStyles.css'

export default function NonFeaturedProjects() {

    const [photoModal, photoModalOpened] = useState(false);
    const [photo, photoSelected] = useState();

    const [nonFeaturedProjects] = useState([
        {
            name: 'Meal Prep, Macro Calculator and Calorie Cost Index',
            category: 'non-featured',
            description: "I Created this over the years when I started hitting the gym. I was interested in measuring where I am compared to my target calories and macro nutrients, as well as the cost. I have a workout card that Dynamically changes your workouts by switching the order of heavy, medium and light, to confuse your muscles.",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/non-featured/large-size/0.jpg"
        },
        {
            name: 'Resistance Workout Card',
            category: 'non-featured',
            description: "This workout card was focusing not just on push or pull, but targeting the muscle groups that are still involved, like shoulders, even if you're working your chest and triceps, your shoulders and biceps are still in use.",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/non-featured/large-size/1.jpg"
        },
        {
            name: 'Cardio Workout Card',
            category: 'non-featured',
            description: "Though the only cardio I was doing was running, it's simple and I'll pickup the design again as I'm still debating on the design for logging running.",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/non-featured/large-size/2.jpg"
        },
        {
            name: 'RUN BUDDY',
            category: 'non-featured',
            description: "Get the exercize you need and the trainer you deserve, get signed up today!",
            application: true,
            link: "https://castroolympias.github.io/Run-Buddy/"
        },
        {
            name: 'TaskMaster Pro',
            category: 'non-featured',
            description: "Stay organized with Taskmaster Pro.",
            application: true,
            link: "https://castroolympias.github.io/TaskMasterPro/"
        },
        {
            name: 'Password Generator',
            category: 'non-featured',
            description: "Create a weak or STRONG random password using special, lowercase, uppercase or numbers, from 8 to 128 caracters long.",
            application: true,
            link: "https://castroolympias.github.io/Passwords/"
        },
        {
            name: 'git it done',
            category: 'non-featured',
            description: "git it done allows for the easy search of community repos, and issues, either by user name or by programming language.",
            application: true,
            link: "https://castroolympias.github.io/git-it-done/"
        },
    ])

    const openPhotoModal = (image, i) => {
        const photoModalUnderlayer = document.getElementById('Photo-Modal-Underlayer')
        const photoModalImage = document.getElementById('Photo-Modal-Image')
        if (photoModal === false) {
            photoSelected({ ...image, index: i })
            photoModalOpened(!photoModal);
        } else {
            photoModalUnderlayer.className = 'Photo-Modal-Underlayer-Closed'
            photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Closed'
            setTimeout(() => {
                photoModalOpened(!photoModal);
            }, 285);
        }
    }

    const directory = 'non-featured'

    return (
        <>
            {/* <div id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Spacing HomeRoute-Header-Dimensions HomeRoute-Header-Shape HomeRoute-Header-Position'>
                    <h1>Non-Featured Projects</h1>
                </button>
            </div> */}

            {photoModal &&
                <>
                    <section onClick={openPhotoModal} id="Photo-Modal-Underlayer" className='Photo-Modal-Underlayer-Opened'>
                    </section>
                    <PhotoModal directory={directory} currentPhoto={photo} closePhotoModal={photoModalOpened} closeIt={openPhotoModal} />
                </>
            }

            <div className='Content-Section-Position Content-Section-Shape Content-Section-Color Content-Section-Dimesions'>

                {nonFeaturedProjects.map((image, i) => (

                    <img
                        className='Photos-Dimensions Photos-Shape'
                        id={nonFeaturedProjects[i].name}
                        src={require(`../../../../assets/images/${directory}/1440/${i}.jpg`)}
                        alt={image.name}
                        key={image.name}
                        onClick={() => openPhotoModal(image, i)}
                    />
                ))}
            </div>
        </>
    )
}